import * as Cookies from "js-cookie";

export default class DarkModeToggleController {
    constructor() {
        this.toggle = document.querySelector(".js-contrast-toggle");
        this.fstoggle = document.querySelector(".js-fs-toggle");

        if (this.toggle) {
            this.init();
        }
    }

    init() {
        this.toggle.addEventListener("click", this.switchTheme, false);
        this.fstoggle.addEventListener("click", this.fsSwitch, false);

        if (Cookies.get("darkMode")) {
            document.documentElement.classList.add("is-dark-mode");
        }

        if (Cookies.get("fsBig")) {
            document.documentElement.classList.add("is-fs-big");
        }
    }

    switchTheme() {
        if (document.documentElement.classList.contains("is-dark-mode")) {
            document.documentElement.classList.remove("is-dark-mode");
            Cookies.remove("darkMode");
        } else {
            document.documentElement.classList.add("is-dark-mode");
            Cookies.set("darkMode", "true", { expires: 7 });
        }
    }

    fsSwitch() {
        if (document.documentElement.classList.contains("is-fs-big")) {
            document.documentElement.classList.remove("is-fs-big");
            Cookies.remove("fsBig");
        } else {
            document.documentElement.classList.add("is-fs-big");
            Cookies.set("fsBig", "true", { expires: 7 });
        }
    }
}
